import { reactive, computed, ref } from 'vue'
import { viewRole, viewRoleSkald } from '@/role/rolechannel'
import { sklad1c } from '@/controlles/auth'
const user = reactive({})
const role = ref(null)
const activity = ref(false)
const channelRole = ref(null)
const skladview = ref(null)

const userState = () => {
  const setUser = async (data, roleID = []) => {
    if (Object.keys(data).length !== 0) {
      user.value = data
      role.value = data.role.slug
      if (['club-owner','club-manager'].includes(role.value)) {
        skladview.value = data.armpoint.warehouses
        sklad1c.value = data.armpoint.namesklad
        channelRole.value = data.role.slug
      } else {
        channelRole.value = viewRole(data.role.slug)
        skladview.value = viewRoleSkald(role.value)
        sklad1c.value = data.armpoint.namesklad
      }
      if (Object.keys(data).length == 0) {
        activity.value = false
      } else { activity.value = true }
    }
  }
  return {
    user: computed(() => user.value),
    role: computed(() => role.value),
    activity: computed(() => activity.value),
    channelRole: computed(() => channelRole.value),
    skladview: computed(() => skladview.value),
    sklad1c: computed(() => sklad1c.value),
    setUser
  }
}

export default userState
